class PasswortVergessen extends HTMLElement {
    connectedCallback() {
        this.addFormSubmitHandler();
        this.setupValidation({
            inputId: 'email-input-passwort-vergessen',
            containerClass: 'email-error-container-passwort-vergessen',
            getTemplateId: this.getEmailErrorTemplateId.bind(this),
        });
        this.triggerScreenReaderErrorMessage();
    }

    addFormSubmitHandler() {
        this.addEventListener('submit', (event) => {this.submitForm(event);});
    }

    submitForm(event) {

        const csrfToken = this.getCsrfToken();
        const csrfCookieName = this.getCsrfCookieName();

        document.cookie = `${csrfCookieName}=${csrfToken}; path=/`;
        return true;
    }

    triggerScreenReaderErrorMessage () {
        const emailErrorInput = document.getElementById('email-input-passwort-vergessen');
        const emailErrorTrigger = document.getElementById('email-error-message-text');
        const emailErrorText = 'email-error-message-text';
        const emailSuccessText = document.getElementById('email-success-message');

        if (emailErrorTrigger) {
            emailErrorInput.setAttribute('aria-describedby', emailErrorText);
            emailErrorInput.focus();
        }

        if (emailSuccessText) {
            emailSuccessText.focus();
        }
    }

    setupValidation({ inputId, containerClass, getTemplateId }) {
        const input = this.querySelector(`#${inputId}`);
        const errorContainer = this.querySelector(`.${containerClass}`);
        if (!input || !errorContainer || typeof getTemplateId !== 'function') return;

        let currentTemplateId = null;

        const showError = () => {
            if (!input.value.trim()) return;

            const templateId = getTemplateId(input);
            if (!templateId || templateId === currentTemplateId) return;

            const template = this.querySelector(`#${templateId}`);
            if (!template) return;

            const content = template.content.cloneNode(true);
            const errorTextId = `${templateId}-text`;

            errorContainer.replaceChildren(content);
            input.setAttribute('aria-invalid', 'true');
            input.setAttribute('aria-describedby', errorTextId);
            currentTemplateId = templateId;
        };

        const clearError = () => {
            if (currentTemplateId !== null) {
                errorContainer.replaceChildren();
                input.setAttribute('aria-invalid', 'false');
                input.removeAttribute('aria-describedby');
                currentTemplateId = null;
            }
        };

        input.addEventListener('blur', () => {
            if (!input.value.trim()) {
                clearError();
            } else if (input.checkValidity()) {
                clearError();
            } else {
                showError();
            }
        });

        input.addEventListener('input', () => {
            clearError();
        });

        input.addEventListener('invalid', (e) => {
            e.preventDefault();
            showError();
        });
    }

    getEmailErrorTemplateId(input) {
        const emailAddress = input.value.trim();

        if (!emailAddress) return 'error-email-required-passwort-vergessen';
        if (!emailAddress.includes('@')) return 'error-email-missing-at-passwort-vergessen';

        const parts = emailAddress.split('@');
        if (parts.length !== 2) return 'error-email-invalid-passwort-vergessen';

        const [local, domain] = parts;

        if (!local) return 'error-email-missing-local-passwort-vergessen';
        if (!domain) return 'error-email-missing-domain-passwort-vergessen';

        if (input.validity.typeMismatch) return 'error-email-invalid-passwort-vergessen';

        return null;
    }

    getCsrfCookieName() {
        return this.getAttribute("csrf-cookie");
    }

    getCsrfToken() {
        return this.getAttribute("csrf-token");
    }
}

customElements.define('passwort-vergessen', PasswortVergessen);